import React, { FC } from 'react';
import { useTranslations } from '@lang';
import SectionContainer from '@common/components/SectionContainer';
import { SectionHero } from '@common/components/SectionHero';
import { ProductGrid } from '@common/components/ProductGrid';
import { SpaItemsGrid } from '@common/components/SpaItemsGrid';
import { VouchersGrid } from '@common/components/VouchersGrid';
import { EventsGrid } from '@common/components/EventsGrid';
import { Routes } from '@common/constants';
import { CategoryItemsWrapper, ItemsTitle, ProductGridWrapper } from './Category.styles';
import { CategoryProps, CategoryReduxProps } from './Category.types';
import { useLabels } from '@common/features/Menu/useLabels';

export const Category: FC<CategoryProps & CategoryReduxProps> = ({ property, category }) => {
  const { t } = useTranslations();
  const labels = useLabels();

  return (
    <div key={category.id}>
      <SectionHero
        backgroundUrl={category?.image?.url}
        summary={category.description}
        title={category.name}
      />
      <SectionContainer>
        {property.isSpaIntegrated && !!category.spaPackages?.length && (
          <CategoryItemsWrapper>
            <ItemsTitle>{labels?.spadays || t('category.spaDays')}</ItemsTitle>
            <SpaItemsGrid items={category.spaPackages} route={Routes.SPA_DAY_DETAIL} />
          </CategoryItemsWrapper>
        )}

        {property.isSpaIntegrated && !!category.treatments?.length && (
          <CategoryItemsWrapper>
            <ItemsTitle>{labels?.treatments || t('category.treatments')}</ItemsTitle>
            <SpaItemsGrid items={category.treatments} route={Routes.SPA_TREATMENT_DETAIL} />
          </CategoryItemsWrapper>
        )}

        {property.isRetailEnabled && !!category.products?.length && (
          <CategoryItemsWrapper>
            <ItemsTitle>{labels?.retail || t('category.shop')}</ItemsTitle>
            <ProductGridWrapper>
              <ProductGrid items={category.products} />
            </ProductGridWrapper>
          </CategoryItemsWrapper>
        )}

        {property.voucherSettings?.isVoucherEnabled && !!category.vouchers?.length && (
          <CategoryItemsWrapper>
            <ItemsTitle>{labels?.vouchers || t('vouchers.vouchers')}</ItemsTitle>
            <VouchersGrid items={category.vouchers} route={Routes.VOUCHER_DETAIL} />
          </CategoryItemsWrapper>
        )}

        {property.eventSettings?.isEventEnabled && !!category.events?.length && (
          <CategoryItemsWrapper>
            <ItemsTitle>{labels?.events || t('events.events')}</ItemsTitle>
            <EventsGrid items={category.events} route={Routes.EVENT_DETAIL} />
          </CategoryItemsWrapper>
        )}

        {property.isSpaIntegrated && !!category.facilities?.length && (
          <CategoryItemsWrapper>
            <ItemsTitle>{labels?.facilities || t('app.facilities')}</ItemsTitle>
            <SpaItemsGrid items={category.facilities} route={Routes.FACILITY_DETAIL} />
          </CategoryItemsWrapper>
        )}
      </SectionContainer>
    </div>
  );
};
